import { useGetCarrierApiV1CarriersCarrierIdGet } from '#/shared/api/generated/shipment/theCargoShipment'

/**
 * Loads the full carrier record behind the dispatched carrier brief. The
 * sidebar renders the brief immediately and fills in FMCSA, contact and
 * insurance details once this resolves.
 */
export function useCarrierInfo(carrierId: string) {
  const { data } = useGetCarrierApiV1CarriersCarrierIdGet(carrierId)
  return { carrier: data?.data }
}
